export default function StatusBridge({ progress = 33, label, className = '' }) {
  return (
    <div className={className}>
      <div className="h-2 w-full overflow-hidden rounded-full bg-surface-variant">
        <span
          className="block h-full rounded-full bg-primary"
          style={{ width: `${Math.min(Math.max(progress, 0), 100)}%` }}
        />
      </div>
      {label ? (
        <p className="mt-3 text-[10px] font-medium uppercase tracking-[0.18em] text-on-surface-variant">
          {label}
        </p>
      ) : null}
    </div>
  )
}
